import { render, staticRenderFns } from "./addClauseModal.vue?vue&type=template&id=8d84eb00&scoped=true"
import script from "./addClauseModal.vue?vue&type=script&lang=js"
export * from "./addClauseModal.vue?vue&type=script&lang=js"
import style0 from "./addClauseModal.vue?vue&type=style&index=0&id=8d84eb00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d84eb00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d84eb00')) {
      api.createRecord('8d84eb00', component.options)
    } else {
      api.reload('8d84eb00', component.options)
    }
    module.hot.accept("./addClauseModal.vue?vue&type=template&id=8d84eb00&scoped=true", function () {
      api.rerender('8d84eb00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/components/addClauseModal.vue"
export default component.exports